import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { ProfileData } from "../Data/ProfileFeedData";
import ModalSlider from "../Components/ModalSlider";

const ProfileBody = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [images, setImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [loadingImages, setLoadingImages] = useState(true); // 로딩 상태 추가

  const openModal = (imgSrc, imgList) => {
    setSelectedImage(imgSrc);
    setImages(imgList);
    setCurrentImageIndex(imgList.indexOf(imgSrc));
    setLoadingImages(true); // 모달 열기 시 로딩 상태 활성화
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setLoadingImages(true); // 모달 닫기 시 로딩 상태 초기화
  };

  const handleAddComment = () => {
    if (newComment.trim() !== "") {
      setComments([...comments, newComment]);
      setNewComment("");
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden"; // 모달이 열리면 스크롤 비활성화
    } else {
      document.body.style.overflow = "auto"; // 모달이 닫히면 스크롤 활성화
    }

    return () => {
      document.body.style.overflow = "auto"; // 컴포넌트 언마운트 시 스크롤 활성화 (클린업)
    };
  }, [isModalOpen]);

  useEffect(() => {
    if (!isModalOpen) return;

    // 모든 이미지가 로드되었는지 확인
    const handleImageLoad = () => {
      setLoadingImages(false);
    };

    // 모달이 열리면 로딩 상태 초기화
    const images = document.querySelectorAll(".modal-image");
    if (images.length === 0) {
      setLoadingImages(false);
    } else {
      let loadedCount = 0;
      images.forEach((img) => {
        if (img.complete) {
          loadedCount += 1;
        } else {
          img.addEventListener("load", () => {
            loadedCount += 1;
            if (loadedCount === images.length) {
              handleImageLoad();
            }
          });
          img.addEventListener("error", handleImageLoad); // 오류 처리 추가
        }
      });
    }

    return () => {
      // Clean up event listeners
      images.forEach((img) => {
        img.removeEventListener("load", handleImageLoad);
        img.removeEventListener("error", handleImageLoad);
      });
    };
  }, [isModalOpen]);

  return (
    <ProfileBodyWrap>
      <ProfileContent>
        <ul>
          {ProfileData.map((data) => (
            <li
              key={data.id}
              onClick={() => openModal(data.imgSrc[0], data.imgSrc)}
            >
              <img src={data.imgSrc[0]} alt="이미지" />
              <div>{data.likeNums}</div>
            </li>
          ))}
        </ul>
      </ProfileContent>

      {isModalOpen && (
        <ModalOverlay onClick={closeModal}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            {loadingImages && <LoadingScreen>로딩 중...</LoadingScreen>}{" "}
            {/* 로딩 화면 추가 */}
            <ModalLeft>
              <ModalSlider
                images={images}
                currentIndex={currentImageIndex}
                setCurrentIndex={setCurrentImageIndex}
                onImageLoad={() => setLoadingImages(false)} // 이미지 로드 시 핸들러
              />
            </ModalLeft>
            <ModalRight>
              <h3>댓글</h3>
              <CommentList>
                <ul>
                  <li>
                    <p>friend1 : 좋아요</p>
                  </li>
                  {comments.map((comment, index) => (
                    <li key={index}>
                      <p>dongsu : {comment}</p>
                    </li>
                  ))}
                </ul>
              </CommentList>

              <textarea
                placeholder="댓글을 입력하세요"
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
              ></textarea>
              <button onClick={handleAddComment}>댓글 달기</button>
            </ModalRight>
          </ModalContent>
        </ModalOverlay>
      )}
    </ProfileBodyWrap>
  );
};

export default ProfileBody;

const ProfileBodyWrap = styled.div`
  width: 100%;
`;

const ProfileContent = styled.div`
  margin: 0 auto;

  @media (max-width: 1264px) {
    max-width: 1264px;
    width: 100%;
    margin: 0 auto;
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    max-width: 935px;
    justify-content: center;
    align-items: center;

    @media (max-width: 1264px) {
      max-width: 935px;
      width: 90%;
    }

    @media (max-width: 767px) {
      max-width: 767px;
      width: 100%;
      padding-bottom: 60px;
    }

    li {
      position: relative;
      width: calc(33.3333% - 10px);
      margin-top: 10px;
      margin-right: 10px;
      cursor: pointer;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      &:nth-child(3n) {
        margin-right: 0;
      }

      &:hover {
        filter: brightness(0.8);

        div {
          display: block;
        }
      }

      @media (max-width: 1264px) {
        width: calc(33.3333% - 10px);
      }

      &::after {
        display: block;
        content: "";
        padding-bottom: 100%;
      }

      div {
        display: none;
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        text-align: center;
      }
    }
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  display: flex;
  background: white;
  width: 70%;
  max-width: 800px;
  height: 60%;
  max-height: 500px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
`;

const ModalLeft = styled.div`
  flex: 1;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalRight = styled.div`
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;

  h3 {
    margin-bottom: 10px;
  }

  textarea {
    resize: none;
    padding: 10px;
    font-size: 16px;
    margin-bottom: 10px;
    height: 20px;
  }

  button {
    align-self: flex-end;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
  }
`;

const CommentList = styled.div`
  width: 100%;
  flex: 1;

  ul {
    list-style: none;
    padding: 0;
  }

  p {
    margin-bottom: 10px;
  }
`;

const LoadingScreen = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2em;
  color: #333;
  z-index: 1001;
`;
